export default __webpack_public_path__ + "static/media/Wheel Hub.ea06c9be.jpg";